// Variables globales pour la gestion des projets
let currentFilter = 'all';
let currentPage = 0;
const projectsPerPage = 4;
let sparkleIntervalId = null;

// Initialisation après chargement du DOM
document.addEventListener("DOMContentLoaded", () => {
  // Animation de chargement
  initLoadingAnimation();
  
  // Observer pour animations au scroll
  initScrollObserver();
  
  // Gestion du menu mobile
  initMobileMenu();
  
  // Gestion des projets
  initProjects();
  
  // Active nav link update on scroll
  initActiveNavLinks();

  // Rotating text animation
  initRotatingText();
  
  // Sparkle Animation
  setTimeout(() => initSparkles(), 2000);
  
  // Initialiser le formulaire de contact
  initContactForm();
});

// Animation d'écran de chargement
function initLoadingAnimation() {
  const loadingScreen = document.getElementById("loading-screen");
  const mainContent = document.getElementById("main-content");
  const typingElement = document.querySelector(".typing-text");

  if (!loadingScreen || !mainContent || !typingElement) return;

  // Typing animation
  const text = "<Hello World/>";
  let index = 0;
  const interval = setInterval(() => {
    typingElement.textContent = text.substring(0, index);
    index++;
    if (index > text.length) {
      clearInterval(interval);
      setTimeout(() => {
        // Marquer le body comme chargé
        document.body.classList.add('loaded');
        
        // Afficher le contenu principal
        setTimeout(() => {
          mainContent.style.opacity = "1";
          // Retirer la classe de chargement
          document.documentElement.classList.remove('js-loading');
        }, 300);
      }, 1000);
    }
  }, 100);
}

// Observers pour les animations au scroll
function initScrollObserver() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll("section").forEach((section) => {
    observer.observe(section);
  });
}

// Gestion du menu mobile
function initMobileMenu() {
  const hamburger = document.getElementById("hamburger");
  const menuOverlay = document.querySelector(".menu-overlay");
  const mobileNavLinks = document.querySelectorAll(".mobile-nav-link");

  if (!hamburger || !menuOverlay) return;

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("active");
    menuOverlay.classList.toggle("active");
    document.body.style.overflow = menuOverlay.classList.contains("active")
      ? "hidden"
      : "";
  });

  mobileNavLinks.forEach((link) => {
    link.addEventListener("click", () => {
      hamburger.classList.remove("active");
      menuOverlay.classList.remove("active");
      document.body.style.overflow = "";
    });
  });
}

// Gestion des liens de navigation actifs
function initActiveNavLinks() {
  const onScroll = () => {
    const sections = document.querySelectorAll("section");
    const navLinks = document.querySelectorAll(".nav-link");

    let current = "";
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (scrollY >= sectionTop - 60) {
        current = section.getAttribute("id");
      }
    });

    navLinks.forEach((link) => {
      link.classList.remove("active");
      if (link.getAttribute("href").slice(1) === current) {
        link.classList.add("active");
      }
    });
  };

  const throttled = typeof window.throttle === 'function'
    ? window.throttle(onScroll, 120)
    : onScroll;

  window.addEventListener("scroll", throttled, { passive: true });
  onScroll();
}

// Initialisation des projets
function initProjects() {
  const projectsContainer = document.getElementById('projects-container');
  if (!projectsContainer) return;
    
  // Rendu initial des projets
  renderProjects();
  
  // Configuration des filtres
  setupProjectFilters();
  
  // Configuration du bouton "voir plus"
  setupLoadMoreButton();
}

// Affichage des projets
function renderProjects() {
  const projectsContainer = document.getElementById('projects-container');
  if (!projectsContainer) return;
  
  // Déterminer les projets à afficher en fonction de la page et du filtre
  let projectsToShow;
  if (currentPage === 0) {
    // Première page - afficher les projets en vedette si aucun filtre spécifique
    projectsToShow = currentFilter === 'all' 
      ? projects.filter(p => p.featured)
      : filterProjects(projects, currentFilter, projectsPerPage);
      
    // Vider le conteneur avant de le remplir
    projectsContainer.innerHTML = '';
  } else {
    // Pages suivantes - charger plus de projets selon le filtre
    const startIndex = currentPage * projectsPerPage;
    const filteredProjects = filterProjects(projects, currentFilter);
    projectsToShow = filteredProjects.slice(startIndex, startIndex + projectsPerPage);
  }
  
  // Aucun projet trouvé
  if (projectsToShow.length === 0 && currentPage === 0) {
    // Utiliser un fragment pour éviter les rendus multiples
    const fragment = document.createDocumentFragment();
    const messageElement = document.createElement('div');
    messageElement.className = 'col-span-2 text-center py-12';
    messageElement.innerHTML = `
      <p class="text-xl text-gray-400">Aucun projet ne correspond à ces critères.</p>
      <button class="outline-button mt-4 reset-filters">Réinitialiser les filtres</button>
    `;
    fragment.appendChild(messageElement);
    projectsContainer.innerHTML = '';
    projectsContainer.appendChild(fragment);
    
    // Ajouter un écouteur d'événement au bouton
    const resetButton = projectsContainer.querySelector('.reset-filters');
    if (resetButton) {
      resetButton.addEventListener('click', () => {
        currentFilter = 'all';
        currentPage = 0;
        updateActiveFilterButton();
        loadProjects();
      });
    }
    return;
  }
  
  // Générer le HTML pour chaque projet
  projectsToShow.forEach(project => {
    const projectCard = document.createElement('div');
    projectCard.innerHTML = createProjectCard(project);
    projectsContainer.appendChild(projectCard.firstElementChild);
  });
}

function updateActiveFilterButton() {
  const filterButtons = document.querySelectorAll('.filter-btn');
  filterButtons.forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.filter === currentFilter);
  });
}

function loadProjects() {
  renderProjects();
  const loadMoreBtn = document.getElementById('load-more-projects');
  if (loadMoreBtn) {
    loadMoreBtn.style.display = '';
  }
}

// Configuration des filtres de projets
function setupProjectFilters() {
  const filterButtons = document.querySelectorAll('.filter-btn');
  if (!filterButtons.length) return;
    
  filterButtons.forEach(btn => {
    btn.addEventListener('click', (event) => {
      // event.stopPropagation(); // Empêcher la propagation
      
      // Mettre à jour l'état actif des boutons
      filterButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      
      // Mettre à jour le filtre et réinitialiser la pagination
      currentFilter = btn.dataset.filter;
      currentPage = 0;
      
      // Réafficher les projets
      renderProjects();
      
      // Réinitialiser le bouton "voir plus"
      const loadMoreBtn = document.getElementById('load-more-projects');
      if (loadMoreBtn) {
        loadMoreBtn.style.display = '';
      }
    });
  });
}

// Configuration du bouton "voir plus"
function setupLoadMoreButton() {
  const loadMoreBtn = document.getElementById('load-more-projects');
  if (!loadMoreBtn) return;
  
  loadMoreBtn.addEventListener('click', (event) => {
    // event.stopPropagation(); // Empêcher la propagation
    
    currentPage++;
    renderProjects();
    
    // Vérifier s'il reste des projets à afficher
    const remainingProjects = filterProjects(projects, currentFilter).slice(
      currentPage * projectsPerPage
    );
    
    if (remainingProjects.length === 0) {
      loadMoreBtn.style.display = 'none';
    }
  });
}

// Animations d'étincelles (sparkles)
function createSparkle() {
  const sparkle = document.createElement("div");
  sparkle.className = "sparkle";

  const size = Math.random() * 10 + 5;
  const duration = Math.random() * 1000 + 1000;

  sparkle.style.width = `${size}px`;
  sparkle.style.height = `${size}px`;
  sparkle.style.left = `${Math.random() * 100}%`;
  sparkle.style.top = `${Math.random() * 100}%`;
  sparkle.style.animation = `sparkle ${duration}ms linear`;

  const particlesContainer = document.getElementById("particles-js");
  if (document.hidden) return;

  if (particlesContainer) {
    // Empêche une accumulation excessive de noeuds animés
    if (particlesContainer.childElementCount > 120) return;

    particlesContainer.appendChild(sparkle);

    setTimeout(() => {
      sparkle.remove();
    }, duration);
  }
}

function initSparkles() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const interval = reducedMotion ? 1400 : 850;

  if (sparkleIntervalId) {
    clearInterval(sparkleIntervalId);
  }

  sparkleIntervalId = setInterval(createSparkle, interval);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && sparkleIntervalId) {
      clearInterval(sparkleIntervalId);
      sparkleIntervalId = null;
      return;
    }

    if (!document.hidden && !sparkleIntervalId) {
      sparkleIntervalId = setInterval(createSparkle, interval);
    }
  });
}

// Initialisation du formulaire de contact avec EmailJS
function initContactForm() {
    const form = document.getElementById('contact-form');
    if (!form) {
        console.error("Formulaire de contact non trouvé");
        return;
    }

    // Initialiser EmailJS
    if (typeof emailjs !== 'undefined') {
        emailjs.init("Hf6uvlF8RZXIQCSel"); // clé publique EmailJS
    } else {
        console.error("EmailJS n'est pas chargé");
        return;
    }
  
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    
    // Animation de chargement
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="loading-dots">Sending</span>';
    
    // Préparation des paramètres
    const templateParams = {
      name: document.getElementById('name').value,
      email: document.getElementById('email').value,
      message: document.getElementById('message').value
    };
    
    // Envoi de l'email avec EmailJS
    // Remplacez ces valeurs par celles de votre compte EmailJS
    emailjs.send(
      'service_5rqx7eo',     // SERVICE_ID
      'template_nbxk2ur',    // TEMPLATE_ID
      templateParams
    )
    .then(function(response) {
      console.log('E-mail envoyé avec succès!', response.status);
      
      // Message de succès
      form.reset();
      submitBtn.classList.remove('glow-button');
      submitBtn.classList.add('success-button');
      submitBtn.innerHTML = '<i class="fas fa-check mr-2"></i>Message envoyé!';
      
      // Réinitialiser le bouton après 3 secondes
      setTimeout(() => {
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
        submitBtn.classList.add('glow-button');
        submitBtn.classList.remove('success-button');
      }, 3000);
    })
    .catch(function(error) {
      console.error('Erreur d\'envoi:', error);
      
      // Message d'erreur
      submitBtn.classList.remove('glow-button');
      submitBtn.classList.add('error-button');
      submitBtn.innerHTML = '<i class="fas fa-exclamation-triangle mr-2"></i>Erreur. Réessayez';
      
      // Réinitialiser le bouton après 3 secondes
      setTimeout(() => {
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
        submitBtn.classList.add('glow-button');
        submitBtn.classList.remove('error-button');
      }, 3000);
    });
  });
}

// Configuration des particles.js
function initParticles() {
  if (typeof particlesJS !== 'function') return;

  const isMobile = window.innerWidth < 768;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cpuCores = navigator.hardwareConcurrency || 4;
  const particleCount = reducedMotion ? 30 : (isMobile || cpuCores <= 4 ? 50 : 80);
  
  particlesJS("particles-js", {
    particles: {
      number: {
        value: particleCount,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#3b82f6",
      },
      shape: {
        type: "circle",
      },
      opacity: {
        value: 0.5,
        random: false,
      },
      size: {
        value: 3,
        random: true,
      },
      line_linked: {
        enable: true,
        distance: 150,
        color: "#3b82f6",
        opacity: 0.2,
        width: 1,
      },
      move: {
        enable: true,
        speed: reducedMotion ? 1.2 : 2,
        direction: "none",
        random: false,
        straight: false,
        out_mode: "out",
        bounce: false,
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: true,
          mode: "grab",
        },
        onclick: {
          enable: true,
          mode: "push",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 140,
          line_linked: {
            opacity: 0.5,
          },
        },
        push: {
          particles_nb: 4,
        },
      },
    },
    retina_detect: true,
  });
}

// Animation de texte machine à écrire dans la section d'accueil
function initRotatingText() {
  const rotatingTextElement = document.getElementById('rotating-text');
  if (!rotatingTextElement) return;
  
  const roles = [
    "Etudiant en master Informatique",
    "Développeur Full-Stack",
    "Architecte Web",
    "DevOps Enthousiaste",
    "Créateur d'Interfaces",
    "Futur Software Engineer",
    "Développeur Web"
  ];
  
  let currentIndex = 0;
  let isDeleting = false;
  let currentText = '';
  let typingSpeed = 100; // vitesse de frappe en ms
  let pauseEnd = 1000; // pause à la fin de l'écriture
  let pauseStart = 500; // pause au début avant d'effacer
  
  function type() {
    // Texte complet du rôle actuel
    const fullText = roles[currentIndex];
    
    // Si en mode effacement, supprimer un caractère
    if (isDeleting) {
      currentText = fullText.substring(0, currentText.length - 1);
      typingSpeed = 50; // effacement plus rapide
    } else {
      // Sinon, ajouter un caractère
      currentText = fullText.substring(0, currentText.length + 1);
      typingSpeed = 100; // frappe normale
    }
    
    // Mettre à jour le texte affiché
    rotatingTextElement.textContent = currentText;
    
    // Déterminer la prochaine étape
    if (!isDeleting && currentText === fullText) {
      // Texte complet écrit, pause avant effacement
      typingSpeed = pauseEnd;
      isDeleting = true;
    } else if (isDeleting && currentText === '') {
      // Texte complètement effacé, passer au suivant
      isDeleting = false;
      currentIndex = (currentIndex + 1) % roles.length;
      typingSpeed = pauseStart;
    }
    
    // Ajouter curseur clignotant (géré par CSS)
    rotatingTextElement.parentElement.classList.toggle('typing', true);
    
    // Poursuivre l'animation
    setTimeout(type, typingSpeed);
  }
  
  // Démarrer l'animation
  type();
}

// Initialiser particles.js
window.addEventListener('load', initParticles);